import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Particle from "./Particle";

const legalStyle = {
  padding: "50px 20px",
  textAlign: "left",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  borderRadius: "10px",
  marginTop: "120px",
  color: "#333",
};

function SupportDotsplosion() {
  const [submitted, setSubmitted] = useState(false);
  const [loginMethod, setLoginMethod] = useState("");
  const [userIdentifier, setUserIdentifier] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent("Dotsplosion - Account Deletion Request");
    const body = encodeURIComponent(
      `Account Deletion Request\n` +
      `------------------------\n` +
      `Sign-in Method: ${loginMethod.charAt(0).toUpperCase() + loginMethod.slice(1)}\n` +
      `E-mail / User ID: ${userIdentifier}\n` +
      `Additional Info: ${additionalInfo || "N/A"}\n` +
      `------------------------\n` +
      `Please delete all my account data associated with the above information.`
    );

    window.location.href = `mailto:sozdemircim@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div className="legal-content" style={legalStyle}>
          <h1 style={{ textAlign: "center", marginBottom: "10px", color: "#2c3e50" }}>
            Dotsplosion
          </h1>
          <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
            Support & Account Deletion
          </p>

          <h3 id="delete-account">Request Account & Data Deletion</h3>

          {!submitted ? (
            <form onSubmit={handleSubmit} style={{ maxWidth: "500px", margin: "0 auto" }}>
              <p>
                To request deletion of your Dotsplosion account and associated data, please fill out the form below.
              </p>

              <div style={{ marginBottom: "1.2em" }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: "0.4em" }}>
                  Sign-in Method
                </label>
                <select
                  value={loginMethod}
                  onChange={(e) => setLoginMethod(e.target.value)}
                  required
                  style={{
                    width: "100%", padding: "0.7em", border: "1px solid #ccc",
                    borderRadius: "8px", fontSize: "1em", fontFamily: "inherit",
                  }}
                >
                  <option value="" disabled>Select your sign-in method</option>
                  <option value="apple">Apple</option>
                  <option value="google">Google</option>
                </select>
              </div>

              <div style={{ marginBottom: "1.2em" }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: "0.4em" }}>
                  E-mail or User ID
                </label>
                <input
                  type="text"
                  value={userIdentifier}
                  onChange={(e) => setUserIdentifier(e.target.value)}
                  placeholder="your@email.com or user ID"
                  required
                  style={{
                    width: "100%", padding: "0.7em", border: "1px solid #ccc",
                    borderRadius: "8px", fontSize: "1em", fontFamily: "inherit", boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{ marginBottom: "1.2em" }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: "0.4em" }}>
                  Additional Information (optional)
                </label>
                <textarea
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                  placeholder="Any details that may help us locate your account..."
                  style={{
                    width: "100%", padding: "0.7em", border: "1px solid #ccc",
                    borderRadius: "8px", fontSize: "1em", fontFamily: "inherit",
                    resize: "vertical", minHeight: "60px", boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{
                background: "#fff3cd", borderRadius: "8px", padding: "1em 1.2em",
                marginTop: "1em", fontSize: "0.92em",
              }}>
                <strong>The following data will be permanently deleted:</strong>
                <ul style={{ margin: "0.5em 0 0 0", paddingLeft: "1.2em" }}>
                  <li>Match history and game results</li>
                  <li>ELO rating and leaderboard position</li>
                  <li>Friend room history</li>
                  <li>Powerup inventory and daily rewards progress</li>
                  <li>All account-related server-side data</li>
                </ul>
              </div>

              <div style={{
                background: "#f0f0f0", borderRadius: "8px", padding: "0.8em 1em",
                marginTop: "0.8em", fontSize: "0.85em", color: "#555",
              }}>
                <strong>Note:</strong> Purchase and transaction records processed through Apple App Store or Google Play
                may be retained by the respective platform as required by law or their policies. Anonymized, aggregated
                analytics data that cannot identify you may also be retained. Deletion requests are processed within
                14 business days.
              </div>

              <button
                type="submit"
                style={{
                  display: "block", width: "100%", padding: "0.8em", marginTop: "1.5em",
                  background: "#d9534f", color: "#fff", border: "none", borderRadius: "8px",
                  fontSize: "1em", fontWeight: 600, cursor: "pointer",
                }}
              >
                Submit Deletion Request
              </button>
            </form>
          ) : (
            <div style={{ textAlign: "center", padding: "2em", color: "#2e7d32" }}>
              <h3 style={{ color: "#2e7d32" }}>Request Submitted</h3>
              <p>
                Your account deletion request has been received. We will process it within{" "}
                <strong>14 business days</strong> and send a confirmation to your e-mail address.
              </p>
              <p>
                If you have any questions, contact us at{" "}
                <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a>.
              </p>
            </div>
          )}

          <hr style={{ margin: "30px 0" }} />

          <h3>Contact Support</h3>
          <p style={{ textAlign: "center" }}>
            Have a question, found a bug, or want to suggest a feature?
          </p>
          <p style={{ textAlign: "center" }}>
            <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a>
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default SupportDotsplosion;
